<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>تقرير آداء الفروع</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                          <div class='panel-heading'>
                            هنا يتم عرض تقرير آداء الفروع
                          </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' v-if='mainValidationErrors'>
                                <ul v-if='mainValidationErrors'>
                                    <li v-for='err in mainValidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class="row">
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                    <label>الفرع</label>
                                    <select class="form-control"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-3 col-sm-6'>
                                <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                                  <div style="padding-top:25px" class='col-lg-3 col-md-3 col-sm-6'>
                                      <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-md btn-block ' >
                                        <b> عرض </b>
                                      </button>
                                  </div>
                                  </div>
                                  <br>
                                  <p class="text-success">الاجمالى: {{totalItem}}</p>
                                  <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                    <thead>
                                      <tr>
                                        <th style='padding:2px;text-align: center'>بيان</th>
                                        <th style='padding:2px;text-align: center'>العدد</th>
                                        <th style='padding:2px;text-align: center'>المبلغ</th>
                                        <th style='padding:2px;text-align: center'>مصاريف التركيب</th>
                                        <th style='padding:2px;text-align: center'>تفاصيل</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr class='odd gradeX' v-for='(record) in records' :key='record.id'>

                                        <td align='center'>{{record.name}}</td>
                                        <td align='center'>{{record.count}}</td>
                                        <td align='center'>{{record.amount}}</td>
                                        <td align='center'>{{record.fee}}</td>
                                        <td align='center'>
                                          <button @click='getDetails(record)' data-toggle='modal' data-target='#myModal' type='button' class='btn btn-outline btn-danger btn-xs'>تفاصيل</button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- Modal -->
             <div class='modal fade' id='myModal' tabindex='-1' role='dialog'  aria-labelledby='myModalLabel' aria-hidden='true'>
               <div class='modal-dialog  modal-lg'>
                 <div class='modal-content'>
                   <div class='modal-header'>
                     <button type='button' class='close' data-dismiss='modal' aria-hidden='true'>&times;</button>
                     <h4 class='modal-title' id='myModalLabel'>{{modalTitle}}</h4>
                   </div>
                     <div class='modal-body'>
                       <fieldset>
                         <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                           <thead>
                             <tr>
                               <th style='padding:2px;text-align: center;'>م</th>
                               <th style='padding:2px;text-align: center'>الكود</th>
                               <th style='padding:2px;text-align: center'>اسم العميل</th>
                               <th style='padding:2px;text-align: center'>المبلغ</th>
                               <th style='padding:2px;text-align: center'>الفنى</th>
                               <th style='padding:2px;text-align: center'>{{userTitle}}</th>
                             </tr>
                           </thead>
                           <tbody>
                             <tr class='odd gradeX' v-for='(record,index) in detailsRecords' :key='index'>

                               <td align='center'>{{index +1 }}</td>
                               <td align='center'>{{record.rec_id}}</td>
                               <td align='center'>{{record.name}}</td>
                               <td align='center'>{{record.presenter}}</td>
                               <td align='center'>{{record.tec}}</td>
                               <td align='center'>{{record.username}}</td>
                             </tr>
                           </tbody>
                         </table>
                       </fieldset>
                     </div>
                     <div class='modal-footer'>
                       <button type='button' class='btn btn-default' data-dismiss='modal'>خروج</button>
                     </div>
                 </div>
                 <!-- /.modal-content -->
               </div>
               <!-- /.modal-dialog -->
             </div>
             <!-- /.modal -->             <!-- /.container-fluid -->
        </div>
</template>
<script>
import tbDate from '@/components/myComponents/tbDate'
import axios from 'axios'
export default {
  components: {
    tbDate
  },
  name: 'RecordRevenueExpenses',
  data () {
    return {
      userTitle: 'المستخدم',
      modalTitle: '',
      dateTitle: 'التاريخ',
      fromTitle: 'من',
      toTitle: 'إلى',
      from_date: '',
      to_date: '',
      today: true,
      validationErrors: '',
      mainValidationErrors: '',
      records: {},
      detailsRecords: {},
      record: {},
      emptyRec: [{id: 0, name: ''}],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingSave: false,
      isLoadingDelete: false,
      RevenueExpense: [],
      branche: {},
      treasuries: {},
      branches: {},
      types: [{id: 1, name: 'مصروف'}, {id: 0, name: 'إيراد'}],
      title: ''
    }
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    // this.branches.unshift(this.emptyRec)
  },
  computed: {
    totalItem () {
      let total = 0
      if (Object.keys(this.records).length !== 0) {
        this.records.forEach(function (item) {
          total += (parseFloat(item.amount))
        })
      }
      return total
    }
  },
  methods: {
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'branch_daily', {
        token: localStorage.getItem('token'),
        branch_id: this.branche,
        date_from: this.from_date,
        date_to: this.to_date
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.mainValidationErrors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    },
    // ==================================================================
    getDetails (rec) {
      this.isLoadingData = true
      this.detailsRecords = ''
      this.modalTitle = rec.name
      axios.post(this.$apiURL + 'branch_daily_details', {
        token: localStorage.getItem('token'),
        branch_id: this.branche,
        date_from: this.from_date,
        date_to: this.to_date,
        rec_id: rec.id
      })
        .then(({ data }) => {
          if (rec.id === 6) {
            this.userTitle = 'المفوض'
          } else {
            this.userTitle = 'المستخدم'
          }
          this.detailsRecords = data
          this.isLoadingData = false
          this.mainValidationErrors = ''
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.mainValidationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reports/BranchPerformance.vue